import { render, staticRenderFns } from "./FilaAtendimentoHibrido.vue?vue&type=template&id=7fafe0e6&scoped=true&"
import script from "./FilaAtendimentoHibrido.vue?vue&type=script&lang=js&"
export * from "./FilaAtendimentoHibrido.vue?vue&type=script&lang=js&"
import style0 from "./FilaAtendimentoHibrido.vue?vue&type=style&index=0&id=7fafe0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fafe0e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VContainer,VProgressCircular,VSkeletonLoader})
